import React, { useEffect } from "react";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Blog from "../components/Home/Blog";
import check from '../images/wealth.png'
import check1 from '../images/pool.png'
import check2 from '../images/briefcase.png'
import check3 from '../images/active.png'
import check4 from '../images/transparency2.png'
import check5 from '../images/client.png'
import { Helmet } from "react-helmet-async";
import img1 from '../images/aif_1.jpg'
import { FaArrowRight, FaArrowsRotate, FaChartLine } from "react-icons/fa6";
import { GiOnTarget, GiTakeMyMoney } from "react-icons/gi";
import { TiDocumentText } from "react-icons/ti";
import { AiFillHourglass } from "react-icons/ai";
const AlternateInvestement = () => {
  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600, 
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);

  return (
    <>
    <Helmet>
        <title>SEBI Registered Equity Investment Advisor - Brighter Mind</title>
       
      </Helmet>
      <Navbar />
      <section className="portfolio-section alternate-investement">
        <div className="container">
          <div className="row">
            <div className="col-12 text-white ">
              <div className="mt-5">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-end">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link> <MdKeyboardArrowRight />
                    </li>
                    <li
                      className="breadcrumb-item text-white"
                      aria-current="page"
                    >
                      Alternative Investment Fund
                    </li>
                  </ol>
                </nav>
              </div>
              <div data-aos="fade-up">
             <h2 className="fw-bold  text-uppercase text-end ">Alternative Investment Fund</h2>
              
             </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mt-5 container">
        <h2 className="heading text-center ">
        Brighter Mind Inevitable Fortune Fund Scheme
        </h2>
        <div className="row mt-3">
          <div className="col-12">
            <p className=" text-dark-emphasis ">
            In March 2025, we are launching our Brighter Mind Inevitable Fortune Fund Scheme with the corpus of $6Million with the vision of attaining a total AUM of $100 Million in next 5 years. The Scheme is designed for investors who seek a balanced approach to growth and stability. Our investment strategy focuses on selecting companies that demonstrate strong fundamentals, sustainable competitive advantages, and consistent performance and meets our stringent stock research framework.
            </p>
            <p className=" text-dark-emphasis ">
            When you invest in the Brighter Mind AIF, you are partnering with a team that is deeply committed to your financial success. With rigorous research methodology our sole focus is on delivering higher alpha to our clients. Our transparent, client-centric approach ensures that you are always informed and confident in your investment choices. 
            </p>

          </div>
        </div>
      </section>
      <section className="mt-5">
  
        <div className="container">
          <h2 className="heading text-center " >
          Fund Overview
          </h2>
          <div className="row gy-4 justify-content-center mt-2">
            <div className="col-lg-2 col-md-4 text-center px-lg-2">
             <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
             <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
             <FaArrowsRotate  className="fs-3"/>
             </div>
              <h6 className="text-center">Fund Structure</h6>
              <p className="text-center small-desc mb-0">Open Ended</p>
             </div>
            </div>
            <div className="col-lg-2 col-md-4 text-center  px-lg-2">
           <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
           <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
           <GiTakeMyMoney className="fs-3"/>
           </div>
              <h6 className="text-center mb-1">Minimum Investment</h6>
              <p className="text-center small-desc mb-0">Rs. 1Crore</p>
           </div>
            </div>
            <div className="col-lg-2 col-md-4 text-center  px-lg-2">
           <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
           <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
           <FaChartLine className="fs-3"/>
           </div>
              <h6 className="text-center mb-1">Style</h6>
              <p className="text-center small-desc mb-0">Multi-cap Long Only Fund</p>
           </div>
            </div>
            <div className="col-lg-2 col-md-4 text-center  px-lg-2">
           <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
           <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
           <TiDocumentText className="fs-3"/>
           </div>
              <h6 className="text-center mb-1">Portfolio Universe</h6>
              <p className="text-center small-desc mb-0">30-35 Stocks</p>
           </div>
            </div>
            <div className="col-lg-2 col-md-4 text-center  px-lg-2">
           <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
           <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
           <AiFillHourglass className="fs-3"/>
           </div>
              <h6 className="text-center mb-1">Investment Horizon</h6>
              <p className="text-center small-desc mb-0">Long Term</p>
           </div>
            </div>
            <div className="col-lg-2 col-md-4 text-center  px-lg-2">
           <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
           <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
           <GiOnTarget className="fs-3"/>
           </div>
              <h6 className="text-center mb-1">Investment Style</h6>
              <p className="text-center small-desc">3M Strategy</p>
           </div>
            </div>
          </div>
          </div>
          </section>
     
  
      <section className="mt-5">
        <div className="container">
          <h2 className="heading text-center">Investment Philosophy</h2>
         <img src={img1} alt="Investment Philosophy" className="w-100 h-100 object-fit-cover"/>
        </div>
      </section>
      <section className="mt-5 fund_benefits_section">
        <div className="fund_benefits  py-5">
        <div className="container">
          <h2 className="heading text-center " >
            Brighter Mind Alternate Investment Fund Benefits
          </h2>
          <div className="row mt-3">
            <di className="col-12">
              <div className="row gy-4 justify-content-center">
                <div className="col-lg-2 col-md-4 col-6  fw-medium">
                 <div className="d-flex flex-column align-items-center benifit-card">
                 <div className="check-box">
                 <img src={check} alt="Check" width={36} /> 
                 </div>
                 <p className="mb-0 fw-medium">Focus on Long Term Wealth</p>
                 </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6  fw-medium">
                <div className="d-flex flex-column align-items-center benifit-card">
               <div className="check-box">
               <img src={check1} alt="Check" width={36} />
               </div>
                <p className="mb-0  fw-medium">Higher Alpha due to pooled fund</p>
                </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6  fw-medium">
                <div className="d-flex flex-column align-items-center benifit-card">
               <div className="check-box">
               <img src={check3} alt="Check" width={36} />
               </div>
                <p className="mb-0  fw-medium">Enhanced Portfolio Diversification</p>
                </div>
                 
                </div>
                <div className="col-lg-2 col-md-4 col-6  fw-medium">
                <div className="d-flex flex-column align-items-center benifit-card">
              <div className="check-box">
              <img src={check2} alt="Check" width={36} /> 
              </div>
                <p className="mb-0  fw-medium">Active Portfolio Management</p>
                </div>
                  
                </div>
                <div className="col-lg-2 col-md-4 col-6 fw-medium">
               <div className="d-flex flex-column align-items-center benifit-card">
              <div className="check-box">
              <img src={check4} alt="Check" width={36} />
              </div>
               <p className="mb-0  fw-medium">Transparency</p>
               </div>
                 
                </div>
                <div className="col-lg-2 col-md-4 col-6 fw-medium">
               <div className="d-flex flex-column align-items-center benifit-card">
              <div className="check-box">
              <img src={check5} alt="Check" width={36} />
              </div>
                <p className="mb-0  fw-medium">Client Centric Approach</p>
                 
               </div>
                </div>
              </div>
            </di> 
          </div>
        </div>
        </div>
      </section>
      <section className="mt-5 container">
        <h2 className="heading text-center ">FAQ</h2>
        <div className="row gy-3 mt-3">
            <div className="col-12">
            <div class="accordion accordion-flush" id="accordionFlushExample">
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
      1.	What type of AIF is Brighter Mind’s Alternate Investment Fund?
      </button>
    </h2>
    <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">Brighter Mind AIF is a long-only category III AIF, with exposure in only listed Indian equities.</div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
      2.	What is the minimum investment amount for AIF?
      </button>
    </h2>
    <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">The minimum investment amount is Rs. 1 Crore for availing the Brighter Mind AIF services.</div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button  collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
      3.	What is tax computation in AIF?
      </button>
    </h2>
    <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">Your wealth created from the scheme is exempted from all the taxation. This is because all the tax computation happens at fund level.</div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
      4.	Is there any lock-in in Brighter Mind AIF?
      </button>
    </h2>
    <div id="flush-collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">Yes, there is a lock-in period of 1 year in Brighter Mind AIF. </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
      5.	How are AIFs regulated in India?
      </button>
    </h2>
    <div id="flush-collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body">AIFs in India are regulated by the Securities and Exchange Board of India (SEBI) under the SEBI (Alternative Investment Funds) Regulations, 2012.</div>
    </div>
  </div>
</div>
            </div>
        </div>
        </section>
      <Blog/>
      <Footer />
    </>
  );
};

export default AlternateInvestement;
